import ProjectMessage from "./project-message"
import DatetimeUtils from "../../../../../../core/gd/utils/datetime-utils"
import ModelEntity from "../../../../../../core/model2/model-entity";
import {EntityType} from "../../../../../../core/gd/const/item";

export default class ProjectUpdate extends ModelEntity {

    public momentCreated      : any
    public projectMessage     : any
    public updateType         : any

    constructor(data:any) {
        super(data.id, EntityType.UPDATE_PROJECT)

        this.momentCreated      = DatetimeUtils.datetimeToMoment(data['momentCreated'])
        this.projectMessage     = new ProjectMessage(data['projectMessage'])
        this.updateType         = data['updateType']
    }
}
